export default {
  finance: {
    fxSources: {
        "TCMB": "Central Bank of Türkiye",
        "ECB": "European Central Bank",
        "FED": "Federal Reserve (H.10)",
        "BOE": "Bank of England",
        "SNB": "Swiss National Bank",
        "BOJ": "Bank of Japan",
        "CBUAE": "Central Bank of the UAE",
        "NBP": "National Bank of Poland",
        "OANDA": "OANDA",
        "XE": "XE.com",
        "MANUEL": "Manual rate entry"
    },
  },
  common: {
    organization: 'Organization', chooseOrganization: 'Choose an organization', newOrganization: 'New organization',
    loading: 'Loading…', retry: 'Retry', search: 'Search', noMatches: 'No matching records.', select: 'Select',
    save: 'Save', revert: 'Revert', cancel: 'Cancel', create: 'Create and open', close: 'Close', edit: 'Edit',
    pending: 'Saving…', saved: 'Changes saved.', dirty: 'Unsaved changes', noChanges: 'No changes.', alreadySaved: 'Already saved; nothing to revert.',
    reason: 'Reason', confirm: 'Confirm', back: 'Back', next: 'Continue', none: 'None', required: 'Check the required fields.',
    errors: { refresh: 'Could not refresh. The last confirmed data is shown; completed changes are retained.', unauthorized: 'Your session has expired. Sign in again.', forbidden: 'You do not have access to this action.', validation: 'The action could not be validated. Check the fields and record status.', upstream: 'The service is unavailable. Changes were not saved.', network: 'Connection failed. Please try again.', contract: 'The server response was unexpected. The action could not be verified.', notFound: 'The record was not found or is unavailable in this scope.' },
    discardTitle: 'Discard unsaved changes?', discardBody: 'Draft changes on this screen will be lost. Saved information is preserved.', discard: 'Discard changes',
  },
  companies: {
    "selectedRoot": "Selected structure",
    "chooseRoot": "Root to configure",
    "structureScopeNote": "Only the selected structure changes; other companies are preserved.",
    "structurePreserved": "Existing companies are preserved. The selected company continues as the same record under the new holding.",
    "structureDowngrade": "An existing holding cannot be converted to a single company.",
    "structureConflict": "The structure changed in another operation. Load the latest data and review it again.",
    "structureRefresh": "Load latest structure",
    "structureReadback": "The change was saved. The latest list could not be loaded; reload without repeating the operation.",
    "independentCompany": "Independent company",
    "parentContext": "Parent holding",
    "structureEmpty": "Create the first structure",
    "structureConfirmed": "The selected structure is preserved.",
    "structureSelectRequired": "Select a root to configure before continuing.",
    "monogramFallback": "used when no icon is available",
    "moneyStorage": "Storage",
    "decimalStorage": "Decimal128 · {scale} decimals (ledger currency)",
    "roundingAwayFromZero": "Halfway away from zero · per line",
    "ledgerRule": "Ledger rule",
    "debitCreditExclusive": "Debit or credit — only one side per line",
    "groupCurrency": "Reporting currency",
    "groupCurrencyLocked": "Group View is reported in this currency. The current currency is locked.",
    "policyReadonly": "These rules cannot be changed in Console.",
    "policyFixed": "Fixed rule",
    "invoiceSettings": "App › Invoicing › Settings",
    "invoiceSettingsNote": "Invoice numbering and terms belong to the company ledger:",
    "moneyScale": "Functional scale",
    "postedRecords": "Posted records",
    "immutableRecords": "Immutable",
    "assetHints": {
      "logoLight": "Print · PDF · email — dark logo",
      "logoDark": "Dark app theme · dark presentation — light logo",
      "iconLight": "Chip · favicon · report seal (light)",
      "iconDark": "Chip · favicon (dark theme)"
    },
    "brandChipNote": "An uploaded icon replaces the monogram in chips. The asset set follows the theme.",
    "brandPaperNote": "— printed report / PDF; paper remains light and uses the light-background assets",
    "chooseAsset": "Drop / click",
    "statusAndOrder": "Status and order",
    "fixedAuthority": "single registration authority for this country",
    "companyShort": "Company",
    "recordActions": "Company actions",
    "auditSlice": "— records for this company only",
    "auditTitle": "Audit trail",
    "holdingContext": "Holding node — linked companies are tracked together in Group View",
    "parentNode": "Parent node", "rootNode": "root node",
    "parentStructureNote": "change the structure in the Configure wizard",
    "allAudit": "All organization activity",
    "addressFields": {
      "countrySearch": "Search country",
      "line2Placeholder": "Floor, apartment, building",
      "line1": "Address line 1",
      "line2": "Address line 2",
      "optional": "— optional",
      "line1TRPlaceholder": "Neighbourhood, street, number",
      "line1Placeholder": "Street and number",
      "line2Unavailable": "The second address line cannot be saved yet.",
      "provinceTR": "Province",
      "districtTR": "District",
      "cityDE": "City (Ort)",
      "city": "City",
      "state": "Region / State",
      "provinceNL": "Provincie",
      "cityEE": "City (Linn)",
      "countyEE": "Maakond",
      "districtCY": "District",
      "cityUS": "City",
      "stateUS": "State",
      "zip": "ZIP",
      "cityGB": "Post town",
      "postcode": "Postcode",
      "plz": "PLZ",
      "postalCode": "Postal code",
      "prefectureJP": "Prefecture",
      "cityJP": "City (市区町村)",
      "postalJP": "郵便番号",
      "emirateAE": "Emirate",
      "areaHK": "Area",
      "districtHK": "District",
      "mapTitle": "Address map",
      "mapUnavailable": "No map center is available for this area.",
      "approximation": "The pin shows the selected city/district center. Parcel verification requires a geocoding integration.",
      "schemaNote": "Fields follow the {country} address schema; administrative areas use canonical lists.",
      "noPostcode": "The {country} address schema does not use postal codes."
    },
    "brandIdentity": "Application identity",
    "brandAssetsNote": "— upload files here; the previews below use this set",
    "lightChip": "Chip preview — light theme",
    "darkChip": "Chip preview — dark theme",
    "customHex": "custom hex",
    "brandDocument": "Document preview",
    "brandDocumentNote": "Sample document — not a real invoice.",
    "legalIdentity": "Legal identity",
    "physicalBranches": "Branches · physical locations",
    "branchNote": "Physical locations. Departments and teams belong in the organization chart.",
    "addBranch": "Add branch",
    "structureChoice": "Structure type",
    "structureDetails": "Holding details",
    "structureSummary": "Summary",
    "holdingChoice": "Holding + subsidiaries",
    "singleChoice": "Single company",
    "holdingExplanation": "Manage multiple companies under a holding.",
    "singleExplanation": "Continue with an independent company.",
    "structureUnavailable": "Structure conversion is currently unavailable. Your existing companies are preserved.",
    "moveExisting": "Change an existing company’s parent",
    "holdingName": "Holding name",
    "holdingLegalName": "Holding legal name",
    "structureWarning": "The new structure preserves company records, units and financial data.",
    "legalSchemaNote": "— {country} legal schema · derived from the registered address country",
    "legalCountries": { "TR": "Türkiye", "NL": "Netherlands", "EE": "Estonia", "CY": "Cyprus", "DE": "Germany", "US": "USA", "GB": "United Kingdom" },
    "taxPolicy": "Rounding",
    "noBranches": "No branches are defined. The headquarters address is available in General.",
    ratePrecision: 'Use a dot as the decimal separator. Up to 28 decimal places are supported; the value is saved without rounding.',
    closed: 'Closed',
    "team": "Team",
    "manager": "Manager",
    "headcount": "Employees",
    headcountCount: '{count} Employee | {count} Employees',
    headcountUnknown: '— Employees',
    "sortOrder": "Sort order",
    "branchAddress": "Branch address",
    "phone": "Phone",
    "email": "Email",
    "clearAddress": "Clear address",
    "inheritCurrency": "Inherit from company ({currency})",
    "makeHeadquarters": "Make headquarters",
    "removeHeadquarters": "Remove headquarters flag",
    "headquartersTitle": "Change the headquarters preference?",
    "setHeadquartersBody": "This branch becomes headquarters. The previous headquarters flag is removed. Historical records are preserved.",
    "unsetHeadquartersBody": "The headquarters flag is removed from this branch. Another branch will not be promoted automatically.",
    "archiveUnitName": "Type the unit name to confirm",
    imageSelected: 'Image selected', noFileSelected: 'No file selected',
    legalLabels: {
      "TR_taxId": "Tax identification number (VKN)",
      "TR_taxOffice": "Tax office",
      "TR_registrationAuthority": "Trade registry office",
      "TR_registrationNumber": "Trade registry number",
      "TR_nationalRegistryNumber": "MERSİS number",
      "TR_registeredEmail": "KEP registered email",
      "DE_taxId": "USt-IdNr.",
      "DE_secondaryTaxId": "Steuernummer",
      "DE_registrationAuthority": "Registergericht (Amtsgericht)",
      "DE_registrationNumber": "Handelsregister-Nr. (HRA/HRB)",
      "DE_registeredEmail": "Official email",
      "FR_taxId": "N° TVA intracommunautaire",
      "FR_registrationNumber": "SIREN",
      "FR_secondaryTaxId": "SIRET (head office)",
      "FR_registrationAuthority": "Greffe (RCS)",
      "FR_registeredEmail": "Official email",
      "IT_taxId": "Partita IVA",
      "IT_secondaryTaxId": "Codice Fiscale",
      "IT_registrationAuthority": "CCIAA",
      "IT_registrationNumber": "REA no",
      "IT_registeredEmail": "PEC (certified email)",
      "GB_registrationNumber": "Company number",
      "GB_taxId": "VAT number",
      "GB_secondaryTaxId": "UTR (Corporation Tax)",
      "US_taxId": "EIN",
      "US_registrationAuthority": "State of incorporation",
      "US_registrationNumber": "State file number",
      "NL_registrationNumber": "KVK-nummer",
      "NL_taxId": "BTW-nummer (VAT)",
      "NL_secondaryTaxId": "RSIN",
      "EE_registrationNumber": "Registrikood",
      "EE_taxId": "KMKR (VAT)",
      "CY_registrationNumber": "Company number (HE)",
      "CY_taxId": "TIC / VAT",
      "JP_taxId": "Hōjin bangō (法人番号)",
      "JP_secondaryTaxId": "Tekikaku no (適格請求書 T+13)",
      "AE_registrationNumber": "Trade License No",
      "AE_registrationAuthority": "Licensing authority",
      "AE_taxId": "TRN (VAT)",
      "other_taxId": "Tax / VAT identification",
      "other_registrationNumber": "Company registration number",
      "other_registrationAuthority": "Registration authority",
      "other_registeredEmail": "Official email"
},
    "newPeriod": "New fiscal period",
    "noPeriods": "No fiscal periods have been opened.",
    "periodOpen": "Open",
    "periodClosed": "Closed",
    "periodStart": "Start date",
    "periodEnd": "End date",
    "closePeriodTitle": "Close this fiscal period?",
    "closePeriodBody": "Posting to this period will stop. This action cannot be reversed here. Enter the closing reason.",
    "addRate": "Add dated rate",
    "noRates": "No historical rates recorded.",
    "sourceCurrency": "Source currency",
    "targetCurrency": "Target ledger currency",
    "rateDate": "Rate date",
    "rateValue": "Rate (1 source currency in target currency)",
    "rateImmutable": "A rate for this currency pair and date cannot be overwritten. Historical document rates are preserved.",
    "fxDateNote": "Conversions use the rate on the document date. Changing the source affects new documents.",
    "providerUnavailable": "The source selection can be saved. Automatic rates from this provider are not available yet.",
    "manualProviderDescription": "Manual rates stored for the transaction date.",
    "recordedRateSource": "Recorded rate source: {source}",
    "manualRateNote": "Manual rates are recorded for a specific date. A missing rate is never treated as zero.",
    "saveSourceFirst": "Save or revert your settings before adding a rate.",
    "taxPercent": "Default tax (%)",
    "taxNote": "Leave blank to clear the default. A value of 0 means an explicit zero tax rate.",
    "usTaxNote": "US sales tax depends on local rules; no company-wide default is set here.",
    "scopeSameCurrency": "Included — same currency",
    "scopeRateAvailable": "Included — dated rate available",
    "scopeMissingRate": "Excluded — missing dated rate",
    "moneyPolicy": "Amounts use {scale} decimal places with halfway rounding away from zero. Posted amounts are immutable.",
    title: 'Companies', subtitle: 'Company structure, corporate information and organizational units', structure: 'Holding structure', configure: 'Configure', newCompany: 'New company',
    firstTitle: 'Create your first organization', firstBody: 'Create an organization to start managing companies and units.', chooseBody: 'Choose an organization to view its companies.',
    empty: 'This organization has no companies yet.', selectCompany: 'Choose a company', missingCompany: 'The selected company was not found in this organization.',
    treeNote: 'This tree feeds the company switcher in the App — monogram and colour appear on its chip.', treeNoteSingle: 'Single-company setup — the App shows no switcher. Adding a second company turns the structure into a holding.', general: 'General', legal: 'Legal', brand: 'Brand', fiscal: 'Fiscal', units: 'Units', audit: 'Audit',
    name: 'Display name', legalName: 'Legal name', country: 'Country', currency: 'Ledger currency', parent: 'Parent company', root: 'Independent company',
    active: 'Active', inactive: 'Inactive', companyCount: 'Companies', subsidiaryCount: 'Subsidiaries', status: 'Status', createdAt: 'Created',
    companyNamePlaceholder: 'Nova Media',
    companyLegalPlaceholder: 'Nova Media Ltd.',
    departmentNamePlaceholder: 'Software',
    teamNamePlaceholder: 'Platform',
    createStatus: 'The record is created as active.',
    createDetails: 'Complete tax details, address and branding in the company details after creating the record.',
    groupLabel: 'GROUP',
    unitSummary: '{count} unit · — people | {count} units · — people',
    focusSummary: '{code} · {manager} · — people (subtree)',
    holdingSummary: '{count} company · {people} · {currency} | {count} companies · {people} · {currency}',
    holdingUnits: '{currency} · {count} unit | {currency} · {count} units',
    holdingPeople: '{count} person | {count} people',
    holdingNoEmployees: 'No employees',
    holdingRead: {
      loading: 'Loading holding summary…',
      unavailable: 'Employee counts are unavailable; unit counts are current.',
      forbidden: 'You do not have permission to view the holding summary.',
      notFound: 'This holding scope is no longer available. Refresh the company list.',
      stale: 'The holding structure changed. Refresh the company list.',
      error: 'The holding summary is currently unavailable.',
    },
    holdingEmpty: 'No linked companies.',
    unitNoMatches: 'No matching units.', unitChildrenCount: '{count} child | {count} children', unitListTeam: 'team',
    unitSearch: 'Search unit, code or manager',
    addDepartmentTeam: 'Department / Team',
    unitLegend: 'Solid border = department, dashed = team (lowest unit) · managers/headcount are supplied by HR',
    holdingChartNote: 'Click a card to open the company; change the structure through Configure.',
    addCompany: 'Add company',
    focusUnit: 'Focus on this unit',
    addUnit: 'Add unit',
    editUnit: 'Edit unit',
    departmentName: 'Department name',
    teamName: 'Team name',
    optionalCode: '— optional',
    rootDepartment: '— root (under company)',
    unitParentSearch: 'Search unit or code', selectDepartment: 'Select a department…',
    parentDepartmentHint: '— empty = root department',
    teamParentHint: '— required; teams cannot contain teams',
    departmentNote: 'Departments can contain subdepartments and teams. The code identifies the unit in expenses and reports.',
    teamNote: 'A team belongs to one department. Its code is the short identifier used in HR and reports.',
    departmentDescription: 'Hierarchical — contains departments and teams',
    teamDescription: 'Leaf unit — belongs to one department',
    hrPanelTitle: 'Manager and headcount',
    hrPanelSource: 'From HR',
    unitHrNote: 'Console defines the hierarchy. Manager assignments and employee-unit relationships are managed in HR.',
    unitHrNewNote: 'Assignment information is not yet available for the new unit.',
    headcountDescription: {
      known: 'Only active employees directly assigned to this department are counted; subdepartments are excluded.',
      unknown: 'The employee count has not been verified yet.',
      unavailable: 'The employee count is currently unavailable.',
      unsupported: 'Team headcounts are not supported yet.',
    },
    headcountRefreshing: 'Refreshing employee counts.',
    createNote: 'The record is created as active. Complete legal and brand information in its detail view.',
    address: 'Head office address', street: 'Street address', city: 'City / District', state: 'State / Region', postalCode: 'Postal code', addressNote: 'The headquarters country determines the legal schema.',
    taxId: 'Tax identification number', vatNumber: 'VAT number', taxOffice: 'Tax office', registrationAuthority: 'Registration authority', registrationNumber: 'Company registration number', secondaryTaxId: 'Secondary tax ID', registeredEmail: 'Official / registered email',
    legalNote: 'The legal name and tax number also appear in the App; the other fields on this tab are visible only in Console.', removeAsset: 'Remove image', removeAssetTitle: 'Remove this brand image?', removeAssetBody: 'This image is removed from the brand set when you Save. Previously issued documents are preserved.', brandAssets: "Upload brand assets", logoLight: 'Logo — light background', logoDark: 'Logo — dark background', iconLight: 'Icon — light background', iconDark: 'Icon — dark background', chooseFile: 'Choose image', monogram: 'Monogram', accentColor: "Accent color", documentFooter: 'Document footer', brandPreview: 'Document and application preview', logoUrl: 'Current logo URL', noLogo: 'No image', previewOnly: 'Unsaved preview', invalidImage: 'Choose a PNG, JPEG or WebP image (up to 5 MB and 4096 × 4096 pixels).',
    currencyLocked: 'Locked after the first document in this ledger. A different currency requires a new company record.', currencyEditable: 'Currency locks when the first document is issued.', periods: 'Fiscal periods', periodNote: 'Closed periods cannot receive entries. Corrections use reversing entries in an open period.', closePeriod: 'Close period', groupScope: 'Group view scope', groupNote: 'Companies without exchange rates cannot be included in consolidation.', fxSource: 'Exchange rate source', manual: 'Manual', fxHistory: 'Historical rates', taxes: 'Default VAT / tax', monetaryPolicy: 'Monetary policy', monetaryNote: 'Posted ledger currency and finalized amounts cannot be modified retrospectively.', archive: 'Archive company', archiveTitle: 'Archive this company?', archiveBody: 'The company is removed from the active list. Historical records and audit events are preserved.', archiveName: 'Type the company name to confirm', deactivateTitle: 'Deactivate this company?', deactivateBody: 'The company becomes inactive for new operations. Existing records are preserved.', deactivate: 'Deactivate', activate: 'Activate',
    unitChartEmpty: 'No units are defined for this company yet — setup is in progress.',
    archiveUnitChildren: 'Move or delete child departments and teams first.',
    archiveUnitReadRequired: 'Load the current unit structure before archiving.',
    archiveConflictTitle: 'Structure changed', archiveConflictBody: 'The structure was changed by another operation in the meantime. Refresh the list and try again.', archiveConflictAction: 'Refresh', archiveRefreshed: 'List refreshed — your entered reason is preserved.',
    unitListMore: 'Showing the first 80 rows — narrow your search ({count} match). | Showing the first 80 rows — narrow your search ({count} matches).',
    unitOverflowTop: '+{count} more unit | +{count} more units',
    unitOverflowTopHint: 'Chart is summarized; view all in the list',
    unitOverflowNested: '+{count} unit | +{count} units',
    unitOverflowNestedHint: 'View all in the list',
    configureTitle: 'Configure company structure', configureBody: "Move an existing company under another company. Review the company and its new parent before confirming.", moveCompany: 'Company to move', reviewStructure: 'Review structure change', applyStructure: 'Apply structure', unitList: 'List', unitChart: 'Chart', newUnit: 'New unit', unitName: 'Unit name', unitCode: 'Code', unitType: 'Unit type', department: 'Department', branch: 'Branch', parentUnit: 'Parent department', headquarters: 'Headquarters', hrNote: 'Console defines hierarchy. Managers and employees are assigned in HR.', noUnits: 'No organizational units yet.', focus: 'Focus', allUnits: 'All units', archiveUnit: 'Archive unit', archiveUnitTitle: 'Archive this unit?', archiveUnitBody: 'The unit is removed from the active structure. Historical relationships are preserved.',
    documentFooterEmpty: 'Document footer not entered yet — this line will appear at the bottom of invoices',
    auditOpen: 'Open organization audit',
  },
}
